<template>
  <v-main :class="{'pb-12': this.$route.name !== 'Cart'}">
    <v-fade-transition mode="out-in">
      <router-view v-if="!$wait.is('loading page')" />
    </v-fade-transition>
    <v-row class="justify-center">
      <v-wait for="loading page">
        <v-dialog
          slot="waiting"
          :key="`dialog`"
          content-class="loading-dialog"
          eager
          fullscreen
          persistent
          transition="fade"
          value="true"
        >
          <v-container
            fill-height
            fluid
          >
            <v-row class="justify-center align-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-row>
          </v-container>
        </v-dialog>
      </v-wait>
      <v-wait for="show spinner">
        <v-dialog
          slot="waiting"
          :key="`dialog`"
          content-class="loading-dialog"
          eager
          fullscreen
          persistent
          transition="fade"
          value="true"
        >
          <v-container
            fluid
            fill-height
          >
            <v-row class="justify-center align-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-row>
          </v-container>
        </v-dialog>
      </v-wait>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: 'AppContent',

  created () {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      this.$wait.start('loading page')
      this.$Progress.start()
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$wait.end('loading page')
      this.$Progress.finish()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/AppContent.vue